// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UserCard.module.css */

.UserCard_user-card__IBao9 {
    position: relative;
    width: 280px;
    min-height: 47vh;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    padding-bottom: 20px;
  }
  .UserCard_availability-icon__ya0dE {
    position: absolute;
    top: 0;
    left: 0;
    width: 40%;
    padding: 10px;
    z-index: 1;
  }
  
  .UserCard_user-photo__TP59x {
    width: 75%;
  margin: auto;
  margin-top: 15px;
  }
  
  .UserCard_rating-section__Fv2XP {
    margin-top: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .UserCard_satisfaction-label__XPZWS {
    color: #2E2E2E;
    text-align: center;
    font-size: 16px;
    font-family: "Lato";
  }
  
  .UserCard_user-name__0OTka {
    color: #3F4C52;
    text-align: center;
    font-size: 26px;
    font-family: "DM Serif Display";
  }
  
  .UserCard_user-speciality__\\+oSa7 {
    color: #2E2E2E;
    text-align: center;
    font-size: 18px;
    font-family: "Lato";
  }
  
  .UserCard_en-savoir-plus__4pZ91 {
    text-align: center;
  }

  .UserCard_cardBody__9Wv1t {
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  
 .UserCard_btn_savoir__-sl3n {
  border: 2px solid #4AAE9B !important;
  background-color: #4AAE9B !important;
  color: rgb(255, 255, 255) !important;
  padding: 10px 28px !important;
  font-size: 16px !important;
  font-family: "Lato";
  cursor: pointer !important;
  font-weight: 500;
  border-radius: 30px !important;
  transition: background-color 0.3s ease-in-out;
  margin-top: 10px;
}
.UserCard_btn_savoir__-sl3n:hover {
  background-color: #A8C9B0 !important;
  color: #ffffff !important;
  border: 2px solid #A8C9B0 !important;
}`, "",{"version":3,"sources":["webpack://./src/Pages/IntervenantsPage/Intervenants/Components/UserCard/UserCard.module.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ,YAAY;EACZ,gBAAgB;EAChB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;EACrB;;CAED;EACC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,8BAA8B;EAC9B,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC","sourcesContent":["/* UserCard.module.css */\n\n.user-card {\n    position: relative;\n    width: 280px;\n    min-height: 47vh;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n  }\n  .availability-icon {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 40%;\n    padding: 10px;\n    z-index: 1;\n  }\n  \n  .user-photo {\n    width: 75%;\n  margin: auto;\n  margin-top: 15px;\n  }\n  \n  .rating-section {\n    margin-top: 10px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .satisfaction-label {\n    color: #2E2E2E;\n    text-align: center;\n    font-size: 16px;\n    font-family: \"Lato\";\n  }\n  \n  .user-name {\n    color: #3F4C52;\n    text-align: center;\n    font-size: 26px;\n    font-family: \"DM Serif Display\";\n  }\n  \n  .user-speciality {\n    color: #2E2E2E;\n    text-align: center;\n    font-size: 18px;\n    font-family: \"Lato\";\n  }\n  \n  .en-savoir-plus {\n    text-align: center;\n  }\n\n  .cardBody {\n    padding: 0 !important;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center;\n  }\n  \n .btn_savoir {\n  border: 2px solid #4AAE9B !important;\n  background-color: #4AAE9B !important;\n  color: rgb(255, 255, 255) !important;\n  padding: 10px 28px !important;\n  font-size: 16px !important;\n  font-family: \"Lato\";\n  cursor: pointer !important;\n  font-weight: 500;\n  border-radius: 30px !important;\n  transition: background-color 0.3s ease-in-out;\n  margin-top: 10px;\n}\n.btn_savoir:hover {\n  background-color: #A8C9B0 !important;\n  color: #ffffff !important;\n  border: 2px solid #A8C9B0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"user-card": `UserCard_user-card__IBao9`,
	"availability-icon": `UserCard_availability-icon__ya0dE`,
	"user-photo": `UserCard_user-photo__TP59x`,
	"rating-section": `UserCard_rating-section__Fv2XP`,
	"satisfaction-label": `UserCard_satisfaction-label__XPZWS`,
	"user-name": `UserCard_user-name__0OTka`,
	"user-speciality": `UserCard_user-speciality__+oSa7`,
	"en-savoir-plus": `UserCard_en-savoir-plus__4pZ91`,
	"cardBody": `UserCard_cardBody__9Wv1t`,
	"btn_savoir": `UserCard_btn_savoir__-sl3n`
};
export default ___CSS_LOADER_EXPORT___;
